import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import React, { useState } from "react";
import { useGetDeliveryProfilesQuery } from "../../../redux/reducer/features/Shipping/shippingSlice";
import { ShipProfile } from "../../../models/features/Shipping/Shipping";
import AddShippingProfile from "./AddShippingProfile";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import LanguageIcon from "@mui/icons-material/Language";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
interface ShippingProfileProps {}

export type ShippingContextType = {
  profile: ShipProfile;
  setProfile: React.Dispatch<React.SetStateAction<ShipProfile>>;
};

export const ShipProfileContext =
  React.createContext<ShippingContextType | null>(null);

const ShippingProfile: React.FunctionComponent<ShippingProfileProps> = () => {
  var navigate = useNavigate();
  const { data, isLoading } = useGetDeliveryProfilesQuery();

  const [deliveryProfiles, setDeliveryProfiles] = React.useState<any[]>([]);
  const [open, setOpen] = React.useState(false);
  const [profileData, setProfileData] = useState<ShipProfile>({
    name: "",
  });

  const handleClose = () => {
    setOpen(false);
  };
  React.useEffect(() => {
    if (data) {
      console.log("Delivery profiles", data);
      setDeliveryProfiles(data.entityList);
    }
  }, [data]);
  return (
    <ShipProfileContext.Provider
      value={{ profile: profileData, setProfile: setProfileData }}
    >
      <Container maxWidth={false}>
        <Box sx={{ flexGrow: 1, pb: 2 }}>
          <Grid container spacing={8}>
            <Grid item xs={4}>
              <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
                Shipping Profile
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Grid container sx={{ justifyContent: "right" }} spacing={2}>
                <Grid item>
                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => setOpen(true)}
                    //startIcon={<SyncIcon />}
                  >
                    Add Profile
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>

        <Card sx={{ borderRadius: 3 }}>
          <CardContent sx={{ minHeight: "60vh" }}>
            <Typography
              sx={{
                fontSize: "1rem",
                fontWeight: 600,
              }}
            >
              Shipping
            </Typography>
            <Typography
              sx={{
                fontSize: "0.875rem",
                color: "#6d7175",
              }}
            >
              Choose where you ship and how much you charge for shipping at
              checkout.
            </Typography>
            <Divider sx={{ borderBottomWidth: 1, mt: 2, mb: 2 }} />
            {isLoading ? (
              <CircularProgress
                sx={{ ml: "50%", mt: "10%" }}
                size="2.8rem"
                color="inherit"
              />
            ) : (
              deliveryProfiles.map((item) => (
                <Box
                  sx={{
                    maxWidth: "100%",
                    height: "15vh",
                    backgroundColor: "#ffffff",
                    border: "1px solid #c9cccf",
                    borderRadius: 3,
                    mb: 3,
                  }}
                >
                  <Grid
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    container
                    height="100%"
                    ml="2%"
                  >
                    <Grid item xs={3}>
                      <Typography
                        sx={{
                          fontSize: "0.875rem",
                          fontWeight: 600,
                        }}
                      >
                        {item.name}
                      </Typography>
                      <br />
                      <Typography
                        sx={{
                          fontSize: "0.875rem",
                          color: "#6d7175",
                        }}
                      >
                        {item.productVariantsCount === -1
                          ? "All products not in other profiles"
                          : item.productVariantsCount + " Products"}
                      </Typography>
                      {/* <Divider
                orientation="horizontal"
                textAlign="right"
                sx={{ borderBottomWidth: 4 }}
              /> */}
                    </Grid>
                    <Grid item xs={3}>
                      <Typography>Rates for</Typography>
                      <br />
                      <Box display="flex" flexDirection="row">
                        <LocationOnIcon sx={{ fontSize: "18px" }} />

                        <Typography sx={{ fontSize: "0.875rem" }}>
                          {item.originLocationCount > 1
                            ? item.originLocationCount + " Locations"
                            : item.originLocationCount + " Location"}
                        </Typography>
                        <ArrowForwardIcon
                          sx={{ mt: "1px", ml: 1, fontSize: "18px" }}
                        />
                        <LanguageIcon sx={{ ml: 0.5, fontSize: "20px" }} />
                        <Typography sx={{ ml: 0.5, fontSize: "0.875rem" }}>
                          {item.zoneCountryCount > 1
                            ? item.zoneCountryCount + " zones"
                            : item.zoneCountryCount + "zone"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography>No Rates for</Typography>
                      <br />
                      <Box display="flex" flexDirection="row">
                        <LocationOnIcon sx={{ fontSize: "18px" }} />

                        <Typography sx={{ fontSize: "0.875rem" }}>
                          {item.locationsWithoutRatesCount > 1
                            ? item.locationsWithoutRatesCount + " Locations"
                            : item.locationsWithoutRatesCount + " Location"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography
                        mr={8}
                        textAlign="right"
                        sx={{
                          fontSize: "0.875rem",
                          color: "#2c6ecb",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const deliveryProfileId = item.id;
                          const idArray = deliveryProfileId.split("/");
                          const lastId = idArray.pop();
                          navigate(`/DeliveryProfileDetail/${lastId}`);
                        }}
                      >
                        Manage
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              ))
            )}
          </CardContent>
        </Card>

        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="xl"
          aria-labelledby="draggable-dialog-title"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h4>Create Shipping Profile</h4>
            <IconButton
              onClick={() => {
                handleClose();
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ height: "90vh" }}>
            <AddShippingProfile handleClose={handleClose}></AddShippingProfile>
          </DialogContent>
        </Dialog>
      </Container>
    </ShipProfileContext.Provider>
  );
};

export default ShippingProfile;
